import { Col, Divider, Row } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import receivableEmbargoBankAccountBankApi from '../../../../../apis/ReceivableEmbargoBankAccounBankApi';
import { Bank, ReceivableEmbargoBankAccountBankFull, ReceivableEmbargoBankAccountBankInfoRequest } from '../../../../../models/Entities';
import alertService from '../../../../../services/AlertService';
import ReceivableEmbargoBankAccountBankInfoReqComponent from './InfoRequestComponent/InfoRequestComponent';

const ReceivableEmbargoBankAccountBankComponent = (props: Props) => {
    const { receivableEmbargoBankAccountBankId } = props;

    /*** HOOKS ***/

    const intl = useIntl();
    const [receivableEmbargoBankAccountBankFull, setReceivableEmbargoBankAccountBankFull] = useState<ReceivableEmbargoBankAccountBankFull>();
    const [, setLoading] = useState<'loading'>();

    /*** EFFECTS ***/

    useEffect(() => {
        const init = async () => {
            try {
                setLoading('loading');
                const receivableEmbargoBankAccountBankFull = await receivableEmbargoBankAccountBankApi.getFull(receivableEmbargoBankAccountBankId);
                setReceivableEmbargoBankAccountBankFull(receivableEmbargoBankAccountBankFull);
            } catch (error) {
                alertService.displayError(error, intl);
            } finally {
                setLoading(undefined);
            }
        };
        init();
    }, [intl, receivableEmbargoBankAccountBankId]);

    // get bank
    const bank: Bank | undefined = useMemo(() => {
        let bank: Bank | undefined;
        if (receivableEmbargoBankAccountBankFull && receivableEmbargoBankAccountBankFull.receivableEmbargoBankAccountBank.councilBank) {
            bank = receivableEmbargoBankAccountBankFull.receivableEmbargoBankAccountBank.councilBank.bank;
        } else if (receivableEmbargoBankAccountBankFull && receivableEmbargoBankAccountBankFull.receivableEmbargoBankAccountBank.bank) {
            bank = receivableEmbargoBankAccountBankFull.receivableEmbargoBankAccountBank.bank;
        }

        return bank;
    }, [receivableEmbargoBankAccountBankFull]);

    /*** METHODS ***/

    // const refresh = async () => {
    //     try {
    //         setLoading('loading');
    //         const receivableEmbargoBankAccountBankFull = await receivableEmbargoBankAccountBankApi.getFull(receivableEmbargoBankAccountBankId);
    //         setReceivableEmbargoBankAccountBankFull(receivableEmbargoBankAccountBankFull);
    //         onUpdate();
    //     } catch (error) {
    //         alertService.displayError(error, intl);
    //     } finally {
    //         setLoading(undefined);
    //     }
    // };

    /*** VISUAL ***/

    return (
        <>
            <Divider orientation="left" plain>
                {bank?.name}
            </Divider>
            <Row gutter={16}>
                {receivableEmbargoBankAccountBankFull &&
                    receivableEmbargoBankAccountBankFull.events.map((event) => {
                        switch (event.phase) {
                            case 'PHASE_1':
                                return (
                                    <Col key={`${event.phase}-${event.id}`} xs={24} md={4}>
                                        <ReceivableEmbargoBankAccountBankInfoReqComponent infoRequest={event as ReceivableEmbargoBankAccountBankInfoRequest} />
                                    </Col>
                                );
                            default:
                                return <></>;
                        }
                    })}
            </Row>
        </>
    );
};
export default ReceivableEmbargoBankAccountBankComponent;

interface Props {
    receivableEmbargoBankAccountBankId: number;
    onUpdate: () => Promise<void>;
    readonly: boolean;
}
